import { useId } from "react";
import { cn } from "@/lib/utils";

/**
 * The glyphs of the wordmark, in logo units (viewBox 0 0 5800 1707), named so
 * the boot animation can move them one at a time. The "c" and the colon after
 * it are the smile.
 */
export const SCANDI_PATHS = {
  s: "M536.643 529.486C655.241 526.395 784.679 549.109 877.759 627.781C945.93 685.4 973.491 754.511 980.973 841.537L780.911 841.542C766.4 739.687 672.488 692.882 578.915 689.584C496.04 686.662 371.129 710.154 366.104 813.717C361.635 905.822 465.449 914.203 533.131 924.174C731.573 949.086 1008.36 964.79 997.862 1232.79C989.373 1449.52 763.306 1534.47 576.245 1528.34C369.307 1526.61 149.881 1431.27 147.452 1195.31L345.16 1195.3C355.389 1325.5 493.207 1375.17 604.839 1368.07C661.75 1366.02 729.107 1351.21 769.381 1308.02C812.299 1262 804.574 1176.64 744.959 1147.45C704.766 1127.770 672.173 1124.4 629.149 1117.27C500.448 1096.19 338.5 1094.02 235.729 1004.53C135.26 917.046 149.001 742.317 236.512 650.221C318.771 563.654 421.58 535.363 536.643 529.486Z",
  c: "M1591.12 531.439C1594.3 531.081 1602.49 531.111 1606.05 531.017L1606.05 749.647L1605.3 749.629C1534.35 748.368 1461.72 779.472 1411.02 828.657C1357.62 880.243 1326.97 950.989 1325.88 1025.23C1324.59 1099.94 1353.34 1172.03 1405.69 1225.34C1458.37 1279.34 1530.6 1309.83 1606.05 1309.89L1606.05 1528.1C1549.09 1528.99 1485.66 1516.89 1432.51 1496.99C1372.39 1475.41 1314.07 1438.52 1267.32 1395.28C1170.52 1305.96 1113.15 1181.86 1107.82 1050.26C1102.17 917.186 1150.22 787.427 1241.17 690.127C1331.84 592.467 1457.92 535.296 1591.12 531.439Z",
  colonTop: "M1846.24 531.423C1918.28 526.575 1980.66 580.943 1985.69 652.97C1990.72 724.996 1936.51 787.508 1864.5 792.722C1792.22 797.955 1729.44 743.508 1724.39 671.222C1719.34 598.936 1773.95 536.289 1846.24 531.423Z",
  colonBottom: "M1847.18 1266.51C1919.26 1262.18 1981.25 1317.01 1985.75 1389.08C1990.25 1461.16 1935.56 1523.27 1863.5 1527.94C1791.2 1532.62 1728.84 1477.71 1724.32 1405.4C1719.81 1333.1 1774.86 1270.86 1847.18 1266.51Z",
  a: "M2518.58 531.417C2544.25 527.931 2607.37 535.738 2633.51 540.958C2718.93 558.015 2804.05 611.614 2851.97 685.364L2851.97 542.582L3055.91 542.579L3055.91 1517.08L2851.97 1517.08L2851.97 1368.67C2838.73 1389.21 2817.77 1410.88 2800.41 1427.84C2725.54 1494.2 2655.51 1522.97 2556.67 1528.01C2273.35 1542.47 2080.52 1336.79 2074.1 1059.45C2070.72 913.1 2100.24 782.112 2202.04 670.535C2285.28 579.286 2396.93 535.96 2518.58 531.417ZM2596.25 1353.98C2671.03 1347.07 2729.81 1318.54 2778.52 1260.32C2842.32 1184.09 2858.57 1083.91 2849.82 987.14C2842.06 901.396 2807.49 821.025 2740.62 764.814C2685.14 718.173 2612.1 701.289 2540.62 707.596C2346.75 727.201 2269.13 904.531 2287.67 1080.88C2305.14 1246.95 2423.17 1371.03 2596.25 1353.98Z",
  n: "M3730.73 531.425C3735.72 530.745 3742.4 531.143 3747.41 531.088C3929.9 529.08 4085.14 632.272 4122.19 816.121C4137.75 893.329 4138.98 948.546 4138.98 1026.9L4138.98 1145.34L4138.97 1517.08L3931.16 1517.08L3931.18 1138.8L3931.2 1028.77C3931.2 946.864 3930.02 870.081 3884.63 797.762C3819.11 693.343 3654.59 684.037 3557.43 747.744C3545.27 755.884 3533.95 765.211 3523.64 775.588C3460.74 838.64 3439.62 929.325 3438.53 1015.75C3438.3 1033.8 3438.42 1051.88 3438.42 1069.94L3438.46 1176.77L3438.53 1517.08L3232.74 1517.08L3232.74 542.582L3434.72 542.579L3434.73 669.48C3440.930 661.874 3447.36 654.466 3454.03 647.268C3528.74 566.863 3623.13 535.227 3730.73 531.425Z",
  d: "M5040.89 178.836L5246.68 178.841C5245.99 228.388 5246.65 279.865 5246.65 329.572L5246.65 628.03L5246.68 1517.08L5042.55 1517.08L5042.56 1371.11C4953.37 1489.35 4834.9 1537.56 4688.13 1527.32C4624.29 1522.87 4572.15 1510.05 4514.14 1482.92C4448.18 1451.44 4391.87 1402.84 4351.07 1342.2C4266.95 1218.35 4248.79 1054.46 4275.15 909.238C4296.91 789.409 4364.41 676.045 4466.53 607.087C4570.35 536.985 4696.35 517.682 4818.96 539.755C4902.72 554.833 4992.69 606.418 5040.9 678.108L5040.89 178.836ZM4787.24 1353.91C4974.39 1338.12 5057.33 1163.43 5040.99 992.044C5024.22 816.191 4915.01 695.384 4731.48 707.581C4654.97 715.392 4597.87 743.129 4548.19 803.428C4484.85 880.311 4468.85 981.649 4478.05 1078.66C4486.12 1163.86 4521.01 1242.58 4587.81 1298C4641.6 1342.63 4716.99 1360.93 4786.14 1354.03L4787.24 1353.91Z",
  i: "M5423.38 542.579L5629.06 542.582L5629.06 1517.09L5423.35 1517.08L5423.38 542.579Z",
  iDot: "M5512.06 177.954C5581.09 170.154 5643.34 219.883 5650.98 288.934C5658.62 357.985 5608.75 420.12 5539.68 427.599C5470.84 435.055 5408.95 385.38 5401.33 316.556C5393.72 247.731 5443.25 185.729 5512.06 177.954Z",
} as const;

/**
 * The brand gradient laid across the whole word in logo units, so it runs from
 * the first letter to the last instead of restarting on every glyph (which is
 * what an objectBoundingBox gradient on a group of paths does).
 */
export function ScandiGradient({ id }: { id: string }) {
  return (
    <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="147" y1="0" x2="5651" y2="0">
      <stop offset="0%" stopColor="var(--brand-from)" />
      <stop offset="100%" stopColor="var(--brand-to)" />
    </linearGradient>
  );
}

/** A DOM-safe id for SVG references; React's ids carry characters url() dislikes. */
export function useSvgId(prefix: string) {
  return `${prefix}-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
}

/**
 * The Scandi wordmark.
 *
 * Paths are filled with `currentColor` so the mark inherits the surrounding
 * text colour, which is what lets one component serve light mode, dark mode and
 * the gradient treatment without shipping three SVGs.
 */
export function ScandiWordmark({
  className,
  gradient = false,
  ...props
}: React.ComponentProps<"svg"> & { gradient?: boolean }) {
  const gradientId = useSvgId("scandi-wordmark-gradient");

  return (
    <svg
      viewBox="0 0 5800 1707"
      role="img"
      aria-label="Scandi"
      className={cn("h-6 w-auto", className)}
      fill={gradient ? `url(#${gradientId})` : "currentColor"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {gradient && (
        <defs>
          <ScandiGradient id={gradientId} />
        </defs>
      )}
      {Object.values(SCANDI_PATHS).map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

/**
 * The smile on its own: the "c" and the colon, turned a quarter left so it
 * reads as an upright face. Stands for the brand where the word will not fit,
 * such as the sidebar collapsed to icons.
 */
export function ScandiSmile({ className, ...props }: React.ComponentProps<"svg">) {
  const gradientId = useSvgId("scandi-smile-gradient");
  return (
    <svg
      viewBox="1040 582 1018 896"
      aria-hidden
      className={cn("size-6", className)}
      fill={`url(#${gradientId})`}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <ScandiGradient id={gradientId} />
      </defs>
      <g transform="rotate(-90 1549 1030)">
        <path d={SCANDI_PATHS.c} />
        <path d={SCANDI_PATHS.colonTop} />
        <path d={SCANDI_PATHS.colonBottom} />
      </g>
    </svg>
  );
}
